import Calculator from "../pages/Calculator"
import Auth from "../pages/Auth"
import Registration from "../pages/Registration"
import Expenses from "../pages/Expenses"
import Positions from "../pages/Positions"
import MainKeeper from "../pages/MainKeeper"
import Primary from "../pages/Primary"
import Bank from "../pages/Bank"
import Fta from "../pages/Fta"
import PayDay from "../pages/PayDay"
import RateOptions from "../pages/RateOptions"
import NotFound from "../pages/NotFound"
import Profile from "../pages/Profile"
import Rates from "../pages/Rates"

export const privateRoutes = [
    { path: '*', component: <NotFound/>, exact: false },
    { path: '/profile', component: <Profile/>, exact: true },
    { path: '/rates', component: <Rates/>, exact: true },
    { path: '/calc/', component: <Calculator/>, exact: true },
    { path: '/expenses', component: <Expenses/>, exact: true },
    { path: '/positions', component: <Positions/>, exact: true },
    { path: '/calc/mainkeeper', component: <MainKeeper/>, exact: true },
    { path: '/calc/primary', component: <Primary/>, exact: true },
    { path: '/calc/bank', component: <Bank/>, exact: true },
    { path: '/calc/fta', component: <Fta/>, exact: true },
    { path: '/calc/payday', component: <PayDay/>, exact: true },
    { path: '/calc/rateoptions', component: <RateOptions/>, exact: true },
]

export const publicRoutes = [
    { path: '*', component: <Auth/>, exact: false },
    { path: '/login', component: <Auth/>, exact: true },
    { path: '/reg', component: <Registration/>, exact: true },
]